module.exports = __webpack_public_path__ + "assets/img/s5-tab-2-0c0bb457.png";